var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1977 17.0001C32.1977 25.4207 25.3714 32.247 16.9508 32.247C8.53011 32.247 1.70384 25.4207 1.70384 17.0001C1.70384 8.57943 8.53011 1.75315 16.9508 1.75315C25.3714 1.75315 32.1977 8.57943 32.1977 17.0001Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.60494
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.951 11.9846C16.5553 11.9846 16.2345 12.3054 16.2345 12.7011V16.2836H12.652C12.2563 16.2836 11.9355 16.6043 11.9355 17.0001C11.9355 17.3958 12.2563 17.7166 12.652 17.7166H16.2345V21.299C16.2345 21.6947 16.5553 22.0155 16.951 22.0155C17.3467 22.0155 17.6675 21.6947 17.6675 21.299V17.7166H21.2499C21.6456 17.7166 21.9664 17.3958 21.9664 17.0001C21.9664 16.6043 21.6456 16.2836 21.2499 16.2836H17.6675V12.7011C17.6675 12.3054 17.3467 11.9846 16.951 11.9846Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a1a57aba6f3eeca97ffc9ab1bc9a759e.svg";
export { ForwardRef as ReactComponent };